var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.body_bg_color),attrs:{"id":"app"}},[_c('preloader',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.preloader),expression:"this.$store.state.preloader"}]}),_c('router-view'),(_vm.cookie)?_c('cookie-law',{attrs:{"message":_vm.cookie,"theme":"dark-lime"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }